import * as React from "react";

import { IconProps } from "./types";

const MagnifyingGlassIcon = ({
  className,
  width = 24,
  height = 25,
  strokeWidth = 2,
}: IconProps) => (
  <svg
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 25 24"
    width={width}
    height={height}
    className={className}
  >
    <path
      d="M11 19.5a8 8 0 1 0 0-16 8 8 0 0 0 0 16ZM21 21.5l-4.35-4.35"
      stroke="inherit"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default MagnifyingGlassIcon;
